import React from 'react';

const FooterNew: React.FC = () => {
  return (
    <footer className="mt-8 mb-6 text-center">
      <div className="flex items-center justify-center gap-2 mb-2 opacity-50 grayscale hover:grayscale-0 hover:opacity-100 transition-all">
        <div className="font-bold text-xl text-sky-500 italic">Unilumin</div>
      </div>
      <p className="text-xs text-slate-400">
        © 2025 Unilumin Technology File Management System | Design: Zora
      </p>
    </footer>
  );
};

export default FooterNew;
